import { mvSlider } from './modules/mvslider';
mvSlider();